import {
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
} from "@chakra-ui/react";
import React from "react";

const SORTBY_MAP = {
  latest: "Latest first",
  oldest: "Oldest first",
  title_asc: "A to Z",
  title_desc: "Z to A",
};
type SortByType = keyof typeof SORTBY_MAP;

interface FilterRowProps {
  onChange: (sortBy: SortByType) => void;
}
export default function FilterRow({ onChange }: FilterRowProps) {
  const [sortBy, setSortBy] = React.useState<SortByType>("latest");

  function handleSortChange(value: SortByType) {
    setSortBy(value);
    onChange(value);
    // Implement sorting logic here based on the selected value
  }
  return (
    <Flex justifyContent="flex-end">
      <Menu closeOnSelect={false}>
        <MenuButton as={Button} variant="ghost" minW="140px" textAlign="left">
          Sort By: {SORTBY_MAP[sortBy]}
        </MenuButton>
        <MenuList minWidth="140px">
          <MenuOptionGroup
            value={sortBy}
            title="Sort By"
            type="radio"
            onChange={(e) => {
              handleSortChange(e as SortByType);
            }}
          >
            <MenuItemOption value="latest" fontSize={"14px"}>
              Latest first
            </MenuItemOption>
            <MenuItemOption value="oldest" fontSize={"14px"}>
              Oldest first
            </MenuItemOption>
            <MenuItemOption value="title_asc" fontSize={"14px"}>
              A to Z
            </MenuItemOption>
            <MenuItemOption value="title_desc" fontSize={"14px"}>
              Z to A
            </MenuItemOption>
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    </Flex>
  );
}
